import React from 'react';
import { FloatingWhatsApp } from 'react-floating-whatsapp';

const WhatsAppWidget = () => {
  const phoneNumber = '+254748600208'; 
  const accountName = 'Techie Interiors';
  const statusMessage = 'Instant replies.....';
  const chatMessage = 'Hello! 👋🏼 How can we help you today?';

  return (
    <FloatingWhatsApp
      phoneNumber={phoneNumber}
      accountName={accountName}
      statusMessage={statusMessage}
      chatMessage={chatMessage}
      allowClickAway
      notification
    //   notificationSound
      notificationDelay={60} 
      avatar="/techLogo.jpeg" 
      className="whatsapp-widget-left" 
    />
  );
};

export default WhatsAppWidget;